import { constants, gql } from '@skunexus/utils';

const { API_PATH } = constants.CONFIG;

export function fetchWarehouse(id) {
    return gql.getGraphQLDetails({
        url: `${API_PATH}/query`,
        config: {
            domain: 'warehouse',
            detailsField: 'details',
        },
        fields: `
            name
            street1
            street2
            city
            country
            region
            postcode
    `,
        payload: { id },
    });
}
